export const SET_UI_OPTIONS = 'SET_UI_OPTIONS';
export const setUiOption = options => ({ type: SET_UI_OPTIONS, options });
